import { render, staticRenderFns } from "./BFormPlan.vue?vue&type=template&id=d349bd66&scoped=true&"
import script from "./BFormPlan.vue?vue&type=script&lang=js&"
export * from "./BFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./BFormPlan.vue?vue&type=style&index=0&id=d349bd66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d349bd66",
  null
  
)

export default component.exports